import { Component, ViewChild } from '@angular/core';
import {
    DiagramModule,
    UndoRedoService,
    SnappingService,
    DataBindingService,
    DiagramComponent,
    HtmlModel,
    BasicShapeModel,
} from '@syncfusion/ej2-angular-diagrams';


@Component({
    selector: 'app-sf-diagram',
    imports: [DiagramModule],
    providers: [UndoRedoService, SnappingService, DataBindingService],
    templateUrl: './sf-diagram.component.html',
    styleUrl: './sf-diagram.component.scss',
})
export class SfDiagramComponent {
    @ViewChild('diagram')
    public diagram?: DiagramComponent;

    public shape: BasicShapeModel = {
        type: 'Basic',
        shape: 'Rectangle',
        cornerRadius: 10,
    };
}
